import axios from "axios";
const API=(process.env.REACT_APP_API_BASE_URL||"http://localhost:8080")+"/api/vaccine-groups";
const headers=()=>({Authorization:`Bearer ${localStorage.getItem("authToken")||""}`});
const vaccineGroupService={
  list:async()=> (await axios.get(API,{headers:headers()})).data,
  save:async (group,id)=> (await (id?axios.put(`${API}/${id}`,group,{headers:headers()}):axios.post(API,group,{headers:headers()}))).data,
  archive:async id=> (await axios.patch(`${API}/${id}/archive`,null,{headers:headers()})).data,
  schedule:async (id,params)=> (await axios.post(`${API}/${id}/schedule`,params,{headers:headers()})).data,
};
export default vaccineGroupService;
